module.exports = __webpack_public_path__ + "img/rnd5.78ffdd6a.jpg";